//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "certificate",
    data() {
        return {
            saving: false,
            member: {},
            value: '',
            text: '',
            tel: '',
            sms: '',
        }
    },
    methods: {
        onSave() {
            if (!this.member.name) {
                this.$toast('请输入姓名');
                return;
            }
            if (!this.member.cardNum) {
                this.$toast('请输入证件号');
                return;
            }
            if (!/^1[2-9]\d{9}$/.test(this.member.phoneNumber)) {
                this.$toast('手机号格式无效');
                return;
            }
            if (!/^\d{6}$/.test(this.member.code)) {
                this.$toast('请输入6位数字验证码');
                return;
            }
            this.saving = true;
            abp.ajax.post('/api/services/app/Member/OwnerCertification', this.member).then(res => {
                this.$toast("认证成功");
                this.$router.back();
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    created() {
    }
}
